import { getConstant } from '../utils';

export const getHarmfulObjects = getConstant('GET_HARMFUL_OBJECTS');
export const getHarmfulObject = getConstant('GET_HARMFUL_OBJECT');
export const getHarmfulObjectDivisions = getConstant('GET_HARMFUL_OBJECT_DIVISIONS');